import { settings } from "../../const/Settings";
import { vp, VPSubs } from "../../managers/vp";
import { MediaListModel } from "../../models/MediaListModel";
import * as isMobile from "ismobilejs";
import { MediaListComponent } from "../MediaListComponent";
import { TopicManager } from "../../managers/TopicManager";
import { MediaItemComponent } from "../MediaItemComponent";
import { DomUtils } from "socios-tools/utils/DomUtils";
const Swiper = require('swiper').default;
const mediaItemFactory = require("../../../html/MediaItem.handlebars");
var Mode;
(function (Mode) {
    Mode[Mode["mob"] = 0] = "mob";
    Mode[Mode["web2"] = 1] = "web2";
    Mode[Mode["web3"] = 2] = "web3";
    Mode[Mode["webBig"] = 3] = "webBig";
    Mode[Mode["webExtraBig"] = 4] = "webExtraBig";
})(Mode || (Mode = {}));
export class Slider extends MediaListComponent {
    constructor() {
        super(...arguments);
        this._loaderIndices = [];
        this._loader = null;
        this._afterAddedNewSlides = false;
        this._loadingNextItems = false;
        this._mouseOverSlider = false;
    }
    init(options) {
        this._options = options;
        this._list = this.getHtml('list');
        const swiperHtml = this.getHtml('swiper', null, true);
        if (swiperHtml) {
            this._scrollMode = !!(options.scrollModeOnMobile && isMobile.any);
            const swiperOptions = {
                spaceBetween: options.spaceBetween,
                threshold: 14,
                navigation: {
                    nextEl: this.getHtml('next'),
                    prevEl: this.getHtml('prev')
                },
                on: {
                    slideChangeTransitionStart: this.slideChangeTransitionStart.bind(this),
                    slideChangeTransitionEnd: this.slideChangeTransitionEnd.bind(this)
                }
            };
            if (options.autoplay) {
                swiperOptions.autoplay = {
                    delay: 6000
                };
            }
            this._swiper = new Swiper(this.getHtml('swiper'), swiperOptions);
            if (!this._scrollMode) {
                this._swiper.on('slideChange', () => {
                    this.update();
                });
                if (options.autoplay) {
                    this.html.addEventListener('mouseover', () => {
                        this._mouseOverSlider = true;
                        this.update();
                    });
                    this.html.addEventListener('mouseout', () => {
                        this._mouseOverSlider = false;
                        this.update();
                    });
                }
            }
            else {
                this.html.setAttribute('data-scroll_mode', 'true');
                this._swiper.detachEvents();
                const scoller = this.getHtml('mob-scroller');
                if (scoller) {
                    scoller.addEventListener('scroll', (e) => {
                        if (scoller.scrollLeft + scoller.offsetWidth >= scoller.scrollWidth - 400) {
                            this.checkForNextPage();
                        }
                        vp.loadImagesInView();
                    });
                }
            }
            if (this._swiper && this._options.autoplay) {
                vp.listener.subscribe((sub) => {
                    switch (sub) {
                        case VPSubs.onDocumentScrollSteps:
                        case VPSubs.onWindowResizeSteps:
                            this.update();
                            break;
                    }
                });
            }
            vp.mediaQueries.onMatches([settings.mediaQueries.mob4, settings.mediaQueries.web1, settings.mediaQueries.web3], (mq) => {
                if (vp.mediaQueries.matches(settings.mediaQueries.mob4)) {
                    this.mode = Mode.mob;
                }
                else if (vp.mediaQueries.matches(settings.mediaQueries.web1)) {
                    this.mode = Mode.web2;
                }
                else if (vp.mediaQueries.matches(settings.mediaQueries.web3)) {
                    this.mode = Mode.web3;
                }
                else {
                    this.mode = Mode.webBig;
                }
            });
        }
        this._model = new MediaListModel({
            items: this.getHtmlList('MediaItemComponent').map((item) => {
                const data = TopicManager.getDataFromTemplate(item.getAttribute('data-id') || '');
                if (!data) {
                    logger.error('cant find data');
                }
                return data;
            }),
            links: {
                "api:next": this.html.getAttribute('data-next-url') || ''
            }
        });
        this.updateListItems();
        if (this._swiper) {
        }
    }
    get activeIndexPage() {
        return Math.floor(this._swiper.activeIndex / this._swiper.params.slidesPerView);
    }
    get totalPages() {
        return Math.floor(this._swiper.slides.length / this._swiper.params.slidesPerView);
    }
    slideChangeTransitionEnd() {
        vp.loadImagesInView();
        this.update();
    }
    slideChangeTransitionStart() {
        if (this._model) {
            if (this.activeIndexPage >= this.totalPages - settings.slideOffsetNextPage - 1) {
                this.checkForNextPage();
            }
        }
    }
    checkForNextPage() {
        if (this._model && this._model.hasNextLink() && !this._loadingNextItems) {
            this._loadingNextItems = true;
            this._model.fetchNextLink().then(() => {
                this._loadingNextItems = false;
                const isInEndSlide = this.activeIndexPage === this.totalPages - 1;
                this._afterAddedNewSlides = true;
                const lastIndex = this._swiper.activeIndex;
                this.updateListItems();
                if (isInEndSlide) {
                    this._swiper.slideTo(lastIndex, 0);
                }
                this._afterAddedNewSlides = false;
            }).catch((e) => {
                logger.error(e);
            });
        }
    }
    updateListItems() {
        if (this._model) {
            this._model.items.forEach((mediaItem) => {
                this.appendMediaItem(mediaItem, false);
            });
            this.showLoaderSlide(this._model.hasNextLink());
        }
        vp.components.pushQueue('MediaItemComponent', MediaItemComponent);
        this.update();
        vp.loadImagesInView();
    }
    showLoaderSlide(value) {
        if (this._scrollMode) {
            if (value) {
                if (!this._loader) {
                    this._loader = DomUtils.createElement('<article class="swiper-slide MediaItem-loader"><div class="MediaItem-space"></div><div class="MediaItem-wrapper"></div></article>');
                }
                this._list.appendChild(this._loader);
            }
            else {
                if (this._loader) {
                    this._list.removeChild(this._loader);
                    this._loader = null;
                }
            }
        }
        else {
            if (value) {
                this.addLoaderItems();
            }
            else {
                this.removeAllLoaderItems();
            }
        }
    }
    addLoaderItems() {
        this.removeAllLoaderItems();
        for (let i = 0; i < this._swiper.params.slidesPerView; i++) {
            this._swiper.appendSlide('<article class="swiper-slide MediaItem-loader"><div class="MediaItem-space"></div><div class="MediaItem-wrapper"></div></article>');
            this._loaderIndices.push(this._swiper.slides.length - 1);
        }
    }
    removeAllLoaderItems() {
        this._swiper.removeSlide(this._loaderIndices);
        this._loaderIndices = [];
    }
    setMediaList(list) {
        this._model = list;
        this.updateListItems();
    }
    hasMediaItemAppended(item) {
        return DomUtils.some(this._swiper.slides, (slide, index) => {
            return slide.getAttribute('data-id') === item.id;
        });
    }
    appendMediaItem(item, update = true) {
        if (!this.hasMediaItemAppended(item)) {
            this._swiper.appendSlide(mediaItemFactory({
                id: item.id,
                url: item.url,
                getImage: item.getImage,
                title: item.title,
                getMediaItemTitle: item.getMediaItemTitle,
                chronologicalDateISO: item.chronologicalDateISO,
                chronologicalDateString: item.chronologicalDateString
            }));
            const raw = item.getRawData();
            window['__data_' + raw.id] = raw;
            if (update) {
                this.update();
            }
        }
        else {
        }
    }
    getMediaItemsHTML() {
        return this._swiper.slides;
    }
    update() {
        if (this._swiper && this._swiper.params) {
            if (this._options.autoplay && !this._mouseOverSlider && DomUtils.inView(this.html)) {
                this._swiper.autoplay.start();
            }
            else {
                this._swiper.autoplay.stop();
            }
            if (this._mode === Mode.webBig) {
                this._swiper.params.slidesPerView = this._options.slidesPerView.webBig;
                this._swiper.params.slidesPerGroup = this._options.slidesPerView.webBig;
            }
            else if (this._mode === Mode.web2) {
                this._swiper.params.slidesPerView = this._options.slidesPerView.web2;
                this._swiper.params.slidesPerGroup = this._options.slidesPerView.web2;
            }
            else if (this._mode === Mode.web3) {
                this._swiper.params.slidesPerView = this._options.slidesPerView.web3;
                this._swiper.params.slidesPerGroup = this._options.slidesPerView.web3;
            }
            else {
                this._swiper.params.slidesPerView = this._options.slidesPerView.mob;
                this._swiper.params.slidesPerGroup = this._options.slidesPerView.mob;
            }
            if (this._afterAddedNewSlides) {
                this._swiper.params.slidesPerGroup = 1;
            }
            this._swiper.update();
            DomUtils.forEach(this._swiper.slides, (slide, index) => {
                if (index >= this._swiper.activeIndex && index < this._swiper.activeIndex + this._swiper.params.slidesPerView) {
                    slide.classList.add('MediaItem-slide-visible');
                }
                else {
                    slide.classList.remove('MediaItem-slide-visible');
                }
            });
        }
    }
    set mode(value) {
        this._mode = value;
        this.update();
    }
}
